// extracted by mini-css-extract-plugin
export default {"header":"Header_header__MY7fH","linkContainer":"Header_linkContainer__8O7UZ","link":"Header_link__z5kDy","linkTypography":"Header_linkTypography__XOOvg"};